module.exports = __webpack_public_path__ + "img/logo.f6ae3d3c.png";